import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../utils';

export interface SaveFileToPhoneOption extends Partial<GeneralInvokeOption> {
  content: string;
  fileName: string;
  invalidParamObj?: '';
}

// 保存图片到手机
export function saveFileToPhone(option: SaveFileToPhoneOption) {
  if (!option.content) {
    return logErrorAndRunFail(
      APINames.Native.SAVE_FILE_TO_PHONE,
      option,
      'parameter error:parameter.content should be String instead of Undefined.'
    );
  }
  if (!option.fileName) {
    return logErrorAndRunFail(
      APINames.Native.SAVE_FILE_TO_PHONE,
      option,
      'parameter error:parameter.fileName should be String instead of Undefined.'
    );
  }
  if (
    paramCheck(APINames.Native.SAVE_FILE_TO_PHONE, option, {
      content: '',
      fileName: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.SAVE_FILE_TO_PHONE,
      option
    );
  }
  return option.invalidParamObj;
}
